import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { MapDataComponent } from "../../modals/map-data/map-data.component";
import { MappingService } from "src/core/services/mapping.service";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import {MessageService, SelectItem} from "primeng/api";
import { SecurityMappingService } from "src/api/services";
import { MappingFilter } from "src/api/models";
import { MapSecurityDataComponent } from "../../modals/map-security-data/map-security-data.component";
import {
  handlePasteWithoutLeadingSpaces,
  preventLeadingSpaceKey,
} from "src/core/utils/input-validation.utils";

@Component({
  selector: "app-security-unprocessed",
  // imports: [],
  templateUrl: "./unprocessed.component.html",
  styleUrl: "./unprocessed.component.css",
  standalone: false,
})
export class SecurityUnprocessedComponent implements OnChanges {
  @Input() isActive: boolean = false;
  private hasLoadedOnce = false;
  securityCount = 'all';
  optionsSecurityCount = [
    {label: 'All', value: 'all'},
    {label: 'One', value: 'one'},
    {label: 'Many', value: 'many'},
    {label: 'None', value: 'none'}
  ] as SelectItem[];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isActive"]?.currentValue === true) {
      this.hasLoadedOnce = false;
    }
  }
  ref!: DynamicDialogRef;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  unprocessedSecurity: any[] = [];
  selectedSecurity: any[] = [];
  selectedDialogRow: any = null;

  // Pagination for Security
  first = 0;
  rows = 10;
  searchByName?: string;
  searchBySecurityType?: string;
  isLoading: boolean = false;
  constructor(
    private _securityMappingService: SecurityMappingService,
    public dialogService: DialogService,
    private _messageService: MessageService
  ) {}

  ngOnInit(): void {}
  getUnprocessedSecurity() {
    const params: MappingFilter = {
      searchByName: this.searchByName,
      searchBySecurityType: this.searchBySecurityType,
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      status: "UNPROCESSED",
      securityCount: this.securityCount
    };
    this.isLoading = true;
    this._securityMappingService.getSecurityMapping(params).subscribe({
      next: (value) => {
        this.unprocessedSecurity = value.UnprocessedSecurity ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.unprocessedSecurity?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }
  onSearch() {
    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getUnprocessedSecurity();
  }
  openMapModal(product?: any, event?: Event) {
    if (event) event.preventDefault();
    this.ref = this.dialogService.open(MapSecurityDataComponent, {
      dismissableMask: false,
      closable: true,
      modal: true,
      showHeader: true,

      style: {
        width: "50vw",
        position: "absolute",
        top: "5%",
        margin: "0 auto",
        left: "0",
        right: "0",
      },
      contentStyle: { overflow: "auto" },
      header: "Mapping",
      data: {
        securities:
          this.selectedSecurity.length > 0 ? this.selectedSecurity : [product],
      },
    });
    this.ref.onClose.subscribe((refresh) => {
      if (refresh) {
        this.getUnprocessedSecurity();
        this.selectedSecurity = [];
      }
    });
  }
  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }
  onGroupMapClick() {
    if (this.selectedSecurity.length > 0) {
      this.openMapModal();
    }
  }
  loadData(event: any) {
    if (!this.isActive) return;
    if (!this.hasLoadedOnce && event.first === 0) {
      this.hasLoadedOnce = true;
    } else if (!this.hasLoadedOnce) {
      return;
    }

    if (event.first > 0 && this.paginator.pageSize !== event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }

    this.paginator.pageSize = event.rows;
    this.getUnprocessedSecurity();
  }
  preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }

  onPaste(
    event: ClipboardEvent,
    field: "searchByName" | "searchBySecurityType"
  ): void {
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
      this[field] = newValue;
    });
  }
}
